import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NavComponent} from './nav/nav.component';
import {AuthComponent} from './components/auth/auth.component';
import {FooterComponent} from './components/footer/footer.component';
import {HomeComponent} from 'projects/paid/src/app/routes/home/home.component';
import {EyeTrackingTestComponent} from 'projects/paid/src/app/routes/eye-tracking-test/eye-tracking-test.component';
import {QuestionnaireComponent} from 'projects/paid/src/app/routes/questionnaire/questionnaire.component';
import {ResultsComponent} from 'projects/paid/src/app/routes/results/results.component';
import {
    NgbAccordionModule, NgbActiveModal,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule, NgbProgressbarModule,
    NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {SigninComponent} from './components/auth/signin/signin.component';
import {SignupComponent} from './components/auth/signup/signup.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {EyeTrackerModule} from 'projects/eye-tracker/src/lib/eye-tracker.module';
import {CalibrationComponent} from './routes/calibration/calibration.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {SharedModule} from 'projects/shared/src/lib/shared.module';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {environment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire/compat';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {TermsAndConditionsComponent} from './routes/terms-and-conditions/terms-and-conditions.component';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {NgxPayPalModule} from 'ngx-paypal';
import {UserSessionsComponent} from './routes/user-sessions/user-sessions.component';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ConfirmSignInComponent} from './components/auth/confirm-sign-in/confirm-sign-in.component';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {FilterByPipe} from './services/filter-by.pipe';
import {FeaturedBlogPostsComponent} from './components/featured-blog-posts/featured-blog-posts.component';
import {HomeHeroComponent} from './components/home-hero/home-hero.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {AboutUsItemComponent} from './components/about-us/about-us-item/about-us-item.component';
import {AchivementComponent} from './components/achivement/achivement.component';
import {PublicationsComponent} from './components/publications/publications.component';
import {PublicationItemComponent} from './components/publications/publication-item/publication-item.component';
import {ForWhoomComponent} from './components/for-whoom/for-whoom.component';
import {ForWhoomItemComponent} from './components/for-whoom/for-whoom-item/for-whoom-item.component';
import {ReviewsItemComponent} from './components/reviews/reviews-item/reviews-item.component';
import {ReviewsPagerComponent} from './components/reviews/reviews-pager/reviews-pager.component';
import {PlansComponent} from './components/plans/plans.component';
import {PlansItemComponent} from './components/plans/plans-item/plans-item.component';
import {FaqComponent} from './components/faq/faq.component';
import {FaqItemComponent} from './components/faq/faq-item/faq-item.component';
import {ChooseTestComponent} from './components/choose-test/choose-test.component';
import {ChooseTestItemComponent} from './components/choose-test/choose-test-item/choose-test-item.component';
import {ResultsContentComponent} from './components/results-content/results-content.component';
import {ResultsWarningComponent} from './components/results-content/results-warning/results-warning.component';
import {
    ResultsTrackerCalibrationComponent
} from './components/results-content/results-tracker/results-tracker-calibration/results-tracker-calibration.component';
import {ResultsTrackerComponent} from './components/results-content/results-tracker/results-tracker.component';
import {
    TrackerArousalPerformanceComponent
} from './components/results-content/results-tracker/tracker-arousal-performance/tracker-arousal-performance.component';
import {
    TrackerVulnerabilityStressComponent
} from './components/results-content/results-tracker/tracker-vulnerability-stress/tracker-vulnerability-stress.component';
import {TrackerCalendarComponent} from './components/results-content/results-tracker/tracker-calendar/tracker-calendar.component';
import {RecommendationsComponent} from './components/results-content/recommendations/recommendations.component';
import {
    RecommendationsItemComponent
} from './components/results-content/recommendations/recommendations-item/recommendations-item.component';
import {SelectTestComponent} from './routes/select-test/select-test.component';
import {ResultsReminderComponent} from './components/results-content/results-tracker/results-reminder/results-reminder.component';
import {ResultsIndexesComponent} from './components/results-content/results-tracker/results-indexes/results-indexes.component';
import {TestResultsComponent} from './components/results-content/test-results/test-results.component';
import {TestPieChartComponent} from './components/results-content/test-results/test-pie-chart/test-pie-chart.component';
import {TestLineChartComponent} from './components/results-content/test-results/test-line-chart/test-line-chart.component';
import {ResultShareLinksComponent} from './components/results-content/test-results/result-share-links/result-share-links.component';
import {PaymentComponent} from './components/payment/payment.component';
import {WhatIsAnimaModalComponent} from './components/what-is-anima-modal/what-is-anima-modal.component';
import {DetailsComponent} from './components/results-content/details/details.component';
import {IArrowComponent} from './components/i-arrow/i-arrow.component';
import {LineProgressComponent} from './components/results-content/details/line-progress/line-progress.component';
import {GetHelpComponent} from './components/get-help/get-help.component';
import {ErrorModalComponent} from './components/error-modal/error-modal.component';
import {AboutPageComponent} from './components/about-page/about-page.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {CalendarModalComponent} from './components/results-content/test-results/calendar-modal/calendar-modal.component';
import {UnsubscribeComponent} from './routes/unsubscribe/unsubscribe.component';
import {TraceService} from '@sentry/angular';
import {NgcCookieConsentConfig, NgcCookieConsentModule} from 'ngx-cookieconsent';
import { IndexDynamicComponent } from './components/results-content/results-tracker/results-indexes/index-dynamic/index-dynamic.component';
import { ForBusinessComponent } from './routes/for-business/for-business.component';
import { HomeHeroBusinessComponent } from './components/home-hero-business/home-hero-business.component';
import { AboutUsBusinessComponent } from './components/about-us-business/about-us-business.component';
import {AboutUsItemBusinessComponent} from './components/about-us-business/about-us-item-business/about-us-item-business.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AiLandingComponent} from './routes/ai-landing/ai-landing.component';
import {HomeHeroAiLandingComponent} from './components/ai-landing/home-hero-ai-landing/home-hero-ai-landing.component';
import {AboutUsAiComponent} from './components/about-us-ai/about-us-ai.component';
import {AboutUsAiItemComponent} from './components/about-us-ai/about-us-ai-item/about-us-ai-item.component';
import {PricingComponent} from './routes/pricing/pricing.component';
import {AfterPaymentComponent} from './components/after-payment/after-payment.component';
import {PromoComponent} from './components/promo/promo.component';
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: environment.cookieDomain
    },
    position: 'bottom',
    theme: 'block',
    palette: {
        popup: {
            background: '#10082f',
            text: '#ffffff',
            link: '#ffffff'
        },
        button: {
            background: '#ffffff',
            text: '#10082f',
            border: 'transparent'
        }
    },
    type: 'info',
    content: {
        message: 'Your Privacy is important to us. Our website by default only uses cookies and similar technology for basic website functions/settings. If you want to stay with this default setting, please click "COOKIE SETTINGS" and "SAVE SETTINGS". By clicking on “ACCEPT ALL COOKIES” you allow cookies for ALL the purposes described in the ',
        dismiss: 'Accept all cookies',
        deny: 'Refuse cookies',
        link: 'COOKIE SETTINGS',
        href: 'terms-and-conditions#cookies',
        policy: 'Cookie Policy'
    }
};

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        EyeTrackingTestComponent,
        QuestionnaireComponent,
        ResultsComponent,
        NavComponent,
        AuthComponent,
        FooterComponent,
        SigninComponent,
        SignupComponent,
        CalibrationComponent,
        TermsAndConditionsComponent,
        UserSessionsComponent,
        ConfirmSignInComponent,
        FilterByPipe,
        FeaturedBlogPostsComponent,
        HomeHeroComponent,
        WhatIsAnimaModalComponent,
        AboutUsComponent,
        AboutUsItemComponent,
        AchivementComponent,
        PublicationsComponent,
        PublicationItemComponent,
        ForWhoomComponent,
        ForWhoomItemComponent,
        ReviewsItemComponent,
        ReviewsPagerComponent,
        PlansComponent,
        PaymentComponent,
        PlansItemComponent,
        FaqComponent,
        FaqItemComponent,
        ChooseTestComponent,
        ChooseTestItemComponent,
        ResultsContentComponent,
        ResultsWarningComponent,
        ResultsTrackerCalibrationComponent,
        ResultsTrackerComponent,
        TrackerArousalPerformanceComponent,
        TrackerVulnerabilityStressComponent,
        TrackerCalendarComponent,
        RecommendationsComponent,
        RecommendationsItemComponent,
        SelectTestComponent,
        ResultsReminderComponent,
        ResultsIndexesComponent,
        TestResultsComponent,
        TestPieChartComponent,
        TestLineChartComponent,
        ResultShareLinksComponent,
        DetailsComponent,
        IArrowComponent,
        LineProgressComponent,
        GetHelpComponent,
        ErrorModalComponent,
        AboutPageComponent,
        CalendarModalComponent,
        UnsubscribeComponent,
        IndexDynamicComponent,
        ForBusinessComponent,
        HomeHeroBusinessComponent,
        AboutUsBusinessComponent,
        AboutUsItemBusinessComponent,
        AiLandingComponent,
        HomeHeroAiLandingComponent,
        AboutUsAiComponent,
        AboutUsAiItemComponent,
        PricingComponent,
        AfterPaymentComponent,
        PromoComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgbAccordionModule,
        NgbDropdownModule,
        NgbAccordionModule,
        NgbModalModule,
        NgbDatepickerModule,
        NgbNavModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireStorageModule,
        AngularFireDatabaseModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        FormlyModule.forRoot({
            types: [
                {
                    name: 'text',
                    extends: 'input',
                    defaultOptions: {
                        templateOptions: {
                            type: 'text',
                        },
                    },
                }
            ],
            validationMessages: [
                {name: 'required', message: 'This field is required'},
            ],
        }),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        FormlyBootstrapModule,
        NgxMaskModule.forRoot(),
        SharedModule.forRoot({env: environment}),
        EyeTrackerModule.forRoot({apiUrl: environment.apiUrl}),
        ToastrModule.forRoot(),
        SlickCarouselModule,
        NgxPayPalModule,
        NgcCookieConsentModule.forRoot(cookieConfig),
        NgbProgressbarModule
    ],
    providers: [
        NgbActiveModal,
        AuthService,
        DataService,
        {provide: 'googleTagManagerId', useValue: environment.googleTagId},
        GoogleTagManagerService,
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [TraceService],
            multi: true,
        },
    ],
    exports: [
        FeaturedBlogPostsComponent,
        TrackerCalendarComponent,
        TrackerArousalPerformanceComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
